import {
  MDBSelect,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { editUser, getMisc } from "../../../apiclients/streamsapi_bridge";
import TelephoneNumbers from "../../TelephoneNumbers";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

const CallingandSMS = ({
  register,
  setValue,
  errors,
  smsPhoneNum,
  useragent,
  callingpermissions,
  usercallerid,
  autociddisplay,
  setSuccessMessage,
  setErrorMessage,
  setCallPermit,
  callPermit,
  watch,
  isstreamsReq,
  setIsloading,
  sid,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  // const [userBInfo, setUserBInfo] = useState(props.userBInfo);
  const [deleteNumbers, setDeleteNumbers] = useState(false);
  const dtoggleShow = () => setDeleteNumbers(!deleteNumbers);
  const [removePHNum, setRemovePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  // const [agentid, setAgentid] = useState("");
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [callerids, setCallerids] = useState([]);
  const [smsNumber, setSMSNumber] = useState("");
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  // const [callPermit, setCallPermit] = useState([]);
  const [smsDefNum, setSMSDefNum] = useState([]);
  const [callandpermission, setCallAndPermission] = useState(0);
  const [userscallerid, setUsersCallerId] = useState("");
  const [clickcall, setClickCall] = useState({});
  const [ispstnNumber, setIsPSTNNumber] = useState(false);
  const [displayautocid, setDisplayAutoCID] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  let smsPhnumberDtlsRef = useRef([]);

  useEffect(() => {
    if (smsPhoneNum.length > 0) {
      setSMSNumber(smsPhoneNum.map((phNum) => phNum?.phnumber));
      setdbPhoneNumbers(smsPhoneNum.map((phNum) => phNum?.phnumber));
      smsPhnumberDtlsRef.current = smsPhoneNum;
    }
    if (usercallerid) {
      setUsersCallerId(usercallerid);
    }

    if (autociddisplay) {
      setDisplayAutoCID(autociddisplay);
    }
  }, [smsPhoneNum, usercallerid, autociddisplay]);

  // useEffect(() => {
  //   if (mobilecallpref) {
  //     setPreOne(mobilecallpref.one);
  //     setPreTwo(mobilecallpref.two);
  //     setPreThree(mobilecallpref.three);
  //     setPreFour(mobilecallpref.four);
  //   }
  // }, [mobilecallpref]);

  useEffect(() => {
    if (callingpermissions) {
      setCallAndPermission(callingpermissions);
    }
    if (usercallerid) {
      setUsersCallerId(usercallerid);
    }
    if (autociddisplay) {
      setDisplayAutoCID(autociddisplay);
    }
  }, [callingpermissions, usercallerid, autociddisplay]);

  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["freeDIDs_SMS", "spam_blocking"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }

    setSourceNumber(
      basicInfo.misc.freeDIDs_SMS?.map((phnum) => phnum.phnumber)
    );
    if (basicInfo.misc?.freeDIDs_SMS?.length > 0) {
      smsPhnumberDtlsRef.current = [
        ...smsPhnumberDtlsRef.current,
        ...basicInfo.misc.freeDIDs_SMS,
      ];
    }
    const spamBlockingOptions = basicInfo.misc.spam_blocking ?? {};
    const spamBlockingList = Object.entries(spamBlockingOptions).map(
      ([value, text]) => ({
        value: parseInt(value),
        text,
      })
    );
    // setspamBlocking(spamBlockingList ?? []);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("added_dids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removed_dids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 3,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid: useragent,
      [fieldName]: updatePHNum,
      logined_user: JSON.parse(sessionStorage.getItem("admin_session"))
        .logined_user,
    };

    console.log(JSON.stringify(update));
    console.log(JSON.stringify(update));
    let saverep = await editUser(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      //debugger;
      if (fieldName === "added_dids") {
        setSMSNumber((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`);
        await fetchData();
      } else {
        const updateAddPHNum = smsNumber.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSMSNumber(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        );
        await fetchData();
      }
    } else {
      if (fieldName === "removed_dids") {
        const modifynum = smsNumber.filter((num) => !updatePHNum.includes(num));
        setSMSNumber([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
      if (saverepeMsg.message?.errors) {
        if (
          saverepeMsg.message?.errors[0].errors &&
          saverepeMsg.message?.errors[0].errors.length > 0
        ) {
          saverepeMsg.message?.errors[0].errors.forEach((err) => {
            if (err.param_name === "logined_user") {
              setErrorMessage(err.message);
            }
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }
      }
    }
    setIsloading(false);
  }

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["calling"], agentid: useragent }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    const callids = (tdata.misc.calling.caller_id ?? []).map((call) => {
      const num = formattedNumber(call.phnum.replace(/[^\d]/g, "").replace(/^1/, "").slice(-10))
      const text = call.addl_info.split(" ").slice(1).join(" ").trim();
      return {
        text: `${num} ${text}`,
        value: call.phnum,
      };
    });
    
    setCallerids(callids);
    const callPermit = (tdata.misc.calling.calling_permissions ?? []).map(
      (permist) => ({ text: permist.classname, value: permist.id })
    );

    setCallPermit(callPermit);
    if (callingpermissions) {
      setCallAndPermission(callingpermissions);
    }
    const smsDef = (tdata.misc.calling.sms_def_num ?? []).map((sms) => ({
      text: sms?.toString(),
      value: sms?.toString(),
    }));
    setSMSDefNum(smsDef);
    let clickCalls = tdata.misc.calling.ctc ?? [];
    if (clickCalls) {
      clickCalls =
        Object.entries(clickCalls)?.map(([key, value]) => ({
          value: parseInt(value),
          text: key,
        })) ?? [];
    }
    setClickCall(clickCalls ?? []);
    // let callassign = tdata.misc.calling.mobile_call_pref ?? [];
    // callassign = Object.entries(callassign)?.map(([key, value]) => ({
    //   value: parseInt(value),
    //   text: key,
    // }));
    // setCallAssignment(callassign);
  }

  // async function fetchCallAssignment() {
  //   console.log(sessionStorage.getItem("admin_session"));
  //   const response = await getMisc(
  //     JSON.parse(sessionStorage.getItem("admin_session")).siteid,
  //     { misc: ["mobile_call_pref"], agentid: useragent }
  //   );
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const tdata = await response.json();
  //   if (!tdata) {
  //     window.alert(`info with id  not found`);
  //     navigate("/");
  //   }
  //   let callassign = tdata.misc.mobile_call_pref ?? [];
  //   callassign = Object.entries(callassign)?.map(([key, value]) => ({
  //     value: parseInt(value),
  //     text: key,
  //   }));
  //   setCallAssignment(callassign);
 
  // }

  useEffect(() => {
    if (useragent !== "") {
      // setallowFalg(false);
      fetchData();
      // fetchCallAssignment();
    }
  }, [useragent]);

  console.log("callPermit ::::::::::::::::::: " + JSON.stringify(callPermit));
  console.log("callingpermission ::::::::::::::::::: " + JSON.stringify(callandpermission));

  return (
    <>
      <div className="general-settings" id="CallingandSMS">
        {t("CallerIDSMSSettings")}
      </div>
      <div className="ps-0">
        {/* Arrangement of order according to Jerome's Enhancements suggested changes */}

        {sid !== "COMMONSEAT" && (
          <>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("AllowUsersCallerID")}</div>
          <div className="phoneselect">
            <div
              {...(isstreamsReq
                ? {
                  title: "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : {})}
            >
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  id="AllowUsersCallerID"
                  {...register("manage_cid")}
                />

                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("DisableCallerID")}</div>
          <div
            {...((isstreamsReq && !watch("manage_cid"))
              ? {
                title: "User does not have permission to edit",
                className: "disabled-form cursor-notAllowed",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                },
              }
              : {})}
          >
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  {...register("disable_cid")}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
          </>
        )}
        {!watch("disable_cid") && (
          <div className="add-numbermain">
            <div className="tel-numbers">{t("callerID")}</div>
            <div className="d-flex w-30">
            <div className="phoneselect w-100">
            <div
            {...((isstreamsReq && !watch("manage_cid"))
              ? {
                title: "User does not have permission to edit",
                className: "disabled-form cursor-notAllowed w-100",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                },
              }
            : { className: "w-100" })}
              >
              <div className="phoneselect w-100">
                <MDBSelect
                  className="w-100"
                  name="San Jose"
                  data={callerids}
                  // {...register("caller_id")}
                  value={userscallerid}
                  search
                  disabled={watch("disable_cid")}
                  onChange={(e) => {
                    if (e && e.value) {
                      setValue("caller_id", e.value, { shouldDirty: true });
                      setUsersCallerId(e.value);
                    }
                  }}
                />
                {/* {callerids &&
                  callerids.map((item) => (
                    <>
                      <option key={item.phnum} value={item.phnum}>
                        {item.addl_info}
                      </option>
                    </>
                  ))} */}
              </div>
            </div>
            </div>
            </div>
          </div>
        )}
        {sid !== "COMMONSEAT" && (


        <TelephoneNumbers
          savedPhoneNumbers={smsNumber}
          setSavedPhoneNumbers={setSMSNumber}
          setSuccessMessage={setSuccessMessage}
          uniqueid={useragent}
          setUpdatePHNum={setUpdatePHNum}
          setUpdateNumbersExecuted={setUpdateNumbersExecuted}
          sourceNumber={sourceNumber}
          setDeleteNumberFlag={setDeleteNumberFlag}
          smsPhNumberDtls={smsPhnumberDtlsRef}
          isstreamsReq={isstreamsReq}
          dbPhoneNumbers={dbPhoneNumbers}
        />
        )}
        <div className="add-numbermain">
          <div className="tel-numbers">{t("CallingPermission")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <div
                {...(isstreamsReq
                  ? {
                    title: "User does not have permission to edit",
                    className: "disabled-form cursor-notAllowed w-100",
                    onClick: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    },
                  }
                  : { className: "w-100" })}
              >
                <div className="phoneselect w-100"> 
                <MDBSelect
                  className="w-100"
                  name="San Jose"
                  search
                  // {...register("calling_permissions")}
                  data={callPermit}
                  value={watch("calling_permissions") * 1}
                  onChange={(e) => {
                    if (e && e.value) {
                      // e.preventDefault();
                      setValue("calling_permissions", parseInt(e.value), {
                        shouldDirty: true,
                      });
                      // setCallAndPermission(e.value);
                    }
                  }}
                />
              </div>
              </div>

              {/* {callPermit &&
                  callPermit.map((item) => (
                    <>
                      <option key={item.id} value={item.id}>
                        {item.classname}
                      </option>
                    </>
                  ))}
              </MDBSelect> */}
            </div>
          </div>
        </div>
        {sid !== "COMMONSEAT" && (
          <>
        {displayautocid && (
          <div className="add-numbermain">
            <div className="tel-numbers">{t("AutoLocalCallerID")}</div>
            <div
            {...((isstreamsReq && !watch("manage_cid"))
              ? {
                  title: "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
              : {})}
          >
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  {...register("automatic_local_cid")}
                />
                <span className="slider round"></span>
              </label>
            </div>
            </div>
          </div>
        )}
{/* 
        <div className="add-numbermain">
          <div className="tel-numbers">{t("SMSEnable")}</div>
          <div className="phoneselect">
            <div
              {...(isstreamsReq
                ? {
                  title: "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : {})}
            >
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  {...register("sms_enabled")}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div> */}
        {
          watch("sms_enabled") &&
        <div className="add-numbermain">
          <div className="tel-numbers">{t("SMSDefaultNo")}</div>
          <div className="phoneselect w-30">
            <div
              {...(isstreamsReq
                ? {
                  title: "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : {})}
            >
               <div className="phoneselect w-100">
              <MDBSelect
                className="w-100"
                name="San Jose"
                value={watch("sms_def_num")?.toString()}
                data={smsDefNum}
                onChange={(e) => {
                  if (e && e.value) {
                    setValue("sms_def_num", e.value.toString(), { shouldDirty: true });
                  }
                }}
                // {...register("sms_def_num")}
                />
              </div>
              {/* {smsDefNum &&
                smsDefNum.length > 0 &&
                smsDefNum.map((defaultNum) => (
                  <>
                    <option key={defaultNum} value={defaultNum}>
                      {defaultNum}
                    </option>
                  </>
                ))}
            </select> */}
            </div>
          </div>
        </div>
        }
        <div className="add-numbermain">
          <div className="tel-numbers">{t("CTC")}</div>
          <div className="phoneselect w-30 flex-column-sm">
            <MDBSelect
              className="w-100"
              name="San Jose"
              // {...register("ctc", {
              //   setValueAs: (value) => Number(value),
              // })}
              value={parseInt(watch("ctc"))}
              data={clickcall?.length > 0 ? clickcall : []}
              onChange={(e) => {
                if (e && e.value) {
                  // e.preventDefault();
                  if (parseInt(e.value) !== 5) {
                    setValue("ctc", parseInt(e.value), {
                      shouldDirty: true,
                    });
                    setIsPSTNNumber(false);
                  } else {
                    setValue("ctc", "", { shouldDirty: true });
                    setIsPSTNNumber(true);
                  }
                }
              }}
            />
            {/* {clickcall &&
                clickcall.length > 0 && clickcall.map((filed) => (
                  <option key={filed.value} value={filed.value}>
                    {filed.text}
                  </option>
                ))}
            </MDBSelect> */}
            {ispstnNumber && (
              <input
                type="text"
                name="ctc"
                className="w-30 mx-1"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("ctc", {
                  validate: (fieldValue) => {
                    if (fieldValue === "") {
                      return "PSTN Number should not be empty";
                    }
                  },
                })}
                onBlur={(e) =>
                  setValue(
                    "ctc",
                    e.target.value !== "" ? parseInt(e.target.value) : "",
                    { shouldDirty: true }
                  )
                }
              />
            )}
            {errors.ctc && <p className="text-danger">{errors.ctc.message}</p>}
          </div>
        </div>

        
          </>
        )}
        
      </div>
    </>
  );
};
export default CallingandSMS;
